import React, { useEffect, useState, useRef } from "react";
import { AxiosResponse, AxiosError } from "axios";
import { Result, DrugCustom } from "../../interface/DrugCustomGroup";
import { DrugCustomGroupAxiosInstance } from "../../Network/DrugCustomGroupAxiosInstance";
import { Option } from "../../interface/Option";
import "react-toastify/dist/ReactToastify.css";
import { ColumnDef } from "@tanstack/react-table";
import { Button } from "../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../components/ui/accordion";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/Label";
import { Toaster } from "../../components/ui/toaster";
import { useToast } from "../../hooks/use-toast";
import DataTable2 from "shared/DataTable2";
import FileUpload from "../uploadFile/UploadFileCustomGroup/UploadFileCustomGroup";
import ListOfDrugCode from "../Shared/DrugCode";
import ListOfDrugMedical from "../Shared/DrugMedicalGroup";
import ListOfDrugCustom from "../Shared/DrugCustomGroup";
const DrugCustomGroups: React.FC = () => {
  // Main data state
  const [items, setItems] = useState<DrugCustom>({ result: [] });

  // Form states
  const [Name, setName] = useState<string>("");
  const [drugCode, setDrugCode] = useState<Option[]>([]);
  const [Description, setDescription] = useState<string>("");
  const [medicalGroups, setMedicalGroups] = useState<Option[]>([]);
  const [CustomGroups, setCustomGroups] = useState<Option[]>([]);
  const [isActive, setIsActive] = useState<boolean>(true);
  // UI control states
  const [editIndex, setEditIndex] = useState<null | number>(null);
  const [clearmedicalGroups, setClearMedicalGroups] = useState(false);
  const [clearcustomGroups, setClearCustomGroups] = useState(false);
  const [clearDrugcode, setClearDrugcode] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  // dialog for details
  const [selectedItem, setSelectedItem] = useState<Result | null>(null);
  const dialogRef = useRef<HTMLDialogElement | null>(null);
  // Get token from localStorage
  const token = localStorage.getItem("token") || "";

  // Initialize toast
  const { toast } = useToast();

  // Fetch initial data on component mount
  useEffect(() => {
    fetchItems();
  }, []);

  // Dialog details control handlers
  const handleOpenDialog = (item: Result) => {
    setSelectedItem(item);
    dialogRef.current?.showModal();
  };

  const handleCloseDialog = () => {
    dialogRef.current?.close();
    setSelectedItem(null);
  };

  // Dialog control handlers
  const handleEditClick = (item: Result) => {
    handleEdit(item);
    setIsDialogOpen(true);
  };

  const handleAddClick = () => {
    setEditIndex(null);
    clear();
    setIsDialogOpen(true);
  };

  // Handlers for form inputs
  const handleMedicalGroupsChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setMedicalGroups(selectedOptions);
  };

  const handleCustomGroupsChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setCustomGroups(selectedOptions);
  };

  const handleDrugcodeChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setDrugCode(selectedOptions);
  };

  // Clear form function
  const clear = () => {
    setName("");
    setDrugCode([]);
    setDescription("");
    setMedicalGroups([]);
    setCustomGroups([]);
    setIsActive(true);
  };

  //Api Functions
  const fetchItems = async (): Promise<void> => {
    try {
      const response: AxiosResponse<{ success: boolean; result: Result[] }> =
        await DrugCustomGroupAxiosInstance.get("getDrugsCustomGroup");
      setItems({ result: [...response.data.result].sort((a: any, b: any) => b.id - a.id) });

      console.log(response.data.result);
    } catch (error) {
      console.error("Error fetching Drug Custom  Group :", error);
      toast({
        title: "Error",
        description: "Failed to fetch Drug Custom  Groups",
        variant: "destructive",
      });
    }
  };

  const addItem = async (): Promise<void> => {
    if (!Name.trim()) {
      toast({
        title: "Error",
        description: "Name is required and cannot be empty.",
        variant: "destructive",
      });
      return;
    }
    //  validation for minimum length
    if (Name.trim().length < 3) {
      toast({
        title: "Error",
        description: "Name  must be at least 3 characters long.",
        variant: "destructive",
      });
      return;
    }
    try {
      if (!drugCode.length || drugCode.every((option) => !option.value)) {
        toast({
          title: "Error",
          description: "At least one Drug code is required.",
          variant: "destructive",
        });
        return;
      }
      const ValuesDrugMedical = medicalGroups.map((option) => option.value);
      const ValuesDrugcode = drugCode.map((option) => option.value);
      const ValuesCustom = CustomGroups.map((option) => option.value);
      const newGroupArray = [
        {
          name: Name,
          drugs: ValuesDrugcode,
          description: Description,
          medical_groups: ValuesDrugMedical,
          custom_groups: ValuesCustom,
          is_active: isActive,
        },
      ];

      const payload = {
        data: newGroupArray,
        token,
      };

      const response = await DrugCustomGroupAxiosInstance.post(
        "addNewDrugsCustomGroup",
        payload
      );

      if (response.data.success) {
        fetchItems();
        clear();
        setIsDialogOpen(false);
        toast({
          title: "Success",
          description: "New Drug Custom Group Added Successfully.",
        });
      } else {
        if (response.data.errors && response.data.errors.length > 0) {
          const errorDetails = response.data.errors[0];
          const errorMessage =
            errorDetails.error ||
            "Failed to add the group due to an unknown error.";
          toast({
            title: "Error",
            description: errorMessage,
            variant: "destructive",
          });
          console.log(errorMessage);
        } else {
          toast({
            title: "Error",
            description: response.data.error || "Failed to add the group.",
            variant: "destructive",
          });
          console.log(response.data.error);
        }
      }
    } catch (error: AxiosError | any) {
      toast({
        title: "Error",
        description:
          error.response?.data?.error || "An unexpected error occurred.",
        variant: "destructive",
      });
      console.error(error.response?.data?.error || error.message);
    }
  };

  const handleEdit = (item: Result) => {
    setName(item.name);
    //Convert or process Drugcode fields
    setDrugCode(
      item.drugs.map((code) => ({
        value: code,
        label: code,
      }))
    );
    //Convert or process medical_groups fields
    const MedicalGroupsData = Array.isArray(item.medical_groups)
      ? item.medical_groups.map((obj) =>
          typeof obj === "string" ? { id: 0, name: obj } : obj
        )
      : [];

    setMedicalGroups(
      MedicalGroupsData.map((obj) => ({
        value: obj.id,
        label: obj.name,
      }))
    );
    //Convert or process CustomGroups fields
    const CustomGroupsData = Array.isArray(item.custom_groups)
      ? item.custom_groups.map((obj) =>
          typeof obj === "string" ? { id: 0, name: obj } : obj
        )
      : [];

    setCustomGroups(
      CustomGroupsData.map((obj) => ({
        value: obj.id,
        label: obj.name,
      }))
    );
    setIsActive(item.is_active);
    setDescription(item.description);
    setEditIndex(item.id);
  };

  const updateItem = async (id: string | number): Promise<void> => {
    if (!Name.trim()) {
      toast({
        title: "Error",
        description: "Name is required and cannot be empty.",
        variant: "destructive",
      });
      return;
    }
    //  validation for minimum length
    if (Name.trim().length < 3) {
      toast({
        title: "Error",
        description: "Name  must be at least 3 characters long.",
        variant: "destructive",
      });
      return;
    }
    if (!drugCode.length || drugCode.every((option) => !option.value)) {
      toast({
        title: "Error",
        description: "At least one Drug code is required.",
        variant: "destructive",
      });
      return;
    }

    try {
      const ValuesDrugMedical = medicalGroups.map((option) => option.value);
      const ValuesDrugcode = drugCode.map((option) => option.value);
      const ValuesCustom = CustomGroups.map((option) => option.value);

      const updatedItem = {
        data: {
          name: Name,
          drugs: ValuesDrugcode,
          description: Description,
          medical_groups: ValuesDrugMedical,
          custom_groups: ValuesCustom,
          is_active: isActive,
          id: id,
        },

        token,
      };
      console.log(updatedItem);

      const response = await DrugCustomGroupAxiosInstance.put(
        `updateDrugsCustomGroup`,
        updatedItem
      );

      if (response.data.success) {
        fetchItems();
        clear();
        setIsDialogOpen(false);
        toast({
          title: "Success",
          description: " Drug Custom  Group updated successfully.",
        });
      }
    } catch (error: AxiosError | any) {
      console.error("Error during the request: ", error);
      toast({
        title: "Error",
        description:
          error.response?.data?.error || "An unexpected error occurred.",
        variant: "destructive",
      });
    }
  };

  const removeItem = async (id: string | number): Promise<void> => {
    try {
      await DrugCustomGroupAxiosInstance.delete(
        `deleteDrugsCustomGroup/${id}`,
        {
          data: { token: token },
        }
      );
      fetchItems();
      toast({
        title: "Success",
        description: "Drug Custom group Deleted Successfully.",
      });
    } catch (error) {
      console.error("Error removing Drug Custom Group :", error);
    }
  };

  const columns: ColumnDef<Result>[] = [
    {
      accessorKey: "id",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          ID
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const item = row.original; //Retrieve the full item
        return (
          <button onClick={() => handleOpenDialog(item)} className="id-button">
            {item.id}
          </button>
        );
      },
    },
    {
      accessorKey: "name",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Name
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },
    {
      accessorKey: "description",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Description
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },
    {
      accessorKey: "drugs",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Drug Codes
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const Drugs = row.getValue("drugs") as string[];
        return Array.isArray(Drugs) ? Drugs.join(", ") : Drugs;
      },
    },
  ];

  return (
    <div className="h5-container mx-auto px-1 pt-16 pb-4">


      <h5
        className="mb-6 flex items-center gap-2"
        style={{ fontWeight: "bolder", fontSize: "22px", marginTop: "15px" }}
      >
        <span className="icon-container">
          <i className="fa-solid fa-pills"></i>
        </span>
        Drug Custom Group
      </h5>

      <FileUpload fetchItems={fetchItems} />
      <DataTable2
        columns={columns}
        data={items.result}
        searchColumns={["name"]}
        addButtonLabel="Add New Group"
        showAddButton={true}
        onEdit={handleEdit}
        onDelete={removeItem}
        onAdd={handleAddClick}
        onEditClick={handleEditClick}
      />

      {Boolean(selectedItem) && (
        <dialog ref={dialogRef} className="custom-dialog" open>
          {selectedItem && (
            <div className="dialog-content">
              {/* top-dialog-close-icon */}
              <button className="dialog-close-icon" onClick={handleCloseDialog}>
                ×
              </button>

              {/* dialog-title */}
              <h2 className="dialog-title">
                <span>Details for ID:</span> {selectedItem.id}
              </h2>

              {/* Content */}
              <div className="dialog-grid">
                <div className="dialog-row three-col-row">
                  <div className="dialog-item">
                    <strong>Name:</strong>
                    <p>{selectedItem.name}</p>
                  </div>
                  <div className="dialog-item">
                    <strong> Description:</strong>
                    <p>{selectedItem.description}</p>
                  </div>
                  <div className="dialog-item">
                    <strong>Is Active:</strong>{" "}
                    <span>{String(selectedItem.is_active)}</span>
                  </div>
                </div>

                <div className="dialog-row three-col-row">
                  <div className="dialog-item">
                    <strong>Drug Codes:</strong>
                    <p>{selectedItem.drugs.join(", ")}</p>
                  </div>
                  <div className="dialog-item">
                    <strong> Drug Custom Groups:</strong>{" "}
                    <span>
                      {selectedItem.custom_groups.map((n) => n.name).join(", ")}
                    </span>
                  </div>
                  <div className="dialog-item">
                    <strong>Drug Medical Groups:</strong>{" "}
                    <span>
                      {selectedItem.medical_groups
                        .map((n) => n.name)
                        .join(", ")}
                    </span>
                  </div>
                </div>
              </div>

              <button className="dialog-close-btn" onClick={handleCloseDialog}>
                Close
              </button>
            </div>
          )}
        </dialog>
      )}
      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              {editIndex === null
                ? "Add Drug Custom Group"
                : "Edit Drug Custom Group"}
            </DialogTitle>
            </DialogHeader>
          <div className="grid grid-cols-2 gap-4 mt-4">
            {/* First Column */}
            <div>
              <div className="mb-4">
                <Label htmlFor="name">Name</Label>
                <Input
                  id="name"
                  value={Name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Name is required It must be more than two letters. "
                />
              </div>
              <div className="mb-4">
                <Label htmlFor="drug_code"> Drug Code:</Label>
                <ListOfDrugCode
                  onChange={handleDrugcodeChange}
                  defaultValue={drugCode}
                  clear={clearDrugcode}
                />
              </div>
              <div className="mb-4">
                <Label htmlFor="customdrag"> Drug Custom Groups: :</Label>
                <ListOfDrugCustom
                  onChange={handleCustomGroupsChange}
                  defaultValue={CustomGroups}
                  clear={clearcustomGroups}
                />
              </div>
            </div>
            {/* Second Column */}
            <div>
              <div className="mb-4">
                <Label htmlFor="description">Description:</Label>
                <Input
                  id="description"
                  value={Description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Description is required It must be more than two letters. "
                />
              </div>
              <div>
                <Label htmlFor="Drug_medicalgroups">
                  {" "}
                  Drug Medical Groups:
                </Label>
                <ListOfDrugMedical
                  onChange={handleMedicalGroupsChange}
                  defaultValue={medicalGroups}
                  clear={clearmedicalGroups}
                />
              </div>
              <div className="mb-3 w-80">
                <Accordion type="single" collapsible>
                  <AccordionItem value="item-1">
                    <AccordionTrigger>Is Active:</AccordionTrigger>
                    <AccordionContent>
                      <div>
                        <label>
                          <input
                            type="radio"
                            name="is_active"
                            value="true"
                            checked={isActive === true}
                            onChange={(e) =>
                              setIsActive(e.target.value === "true")
                            }
                          />{" "}
                          True
                        </label>
                        <label className="ml-4">
                          <input
                            type="radio"
                            name="is_active"
                            value="false"
                            checked={isActive === false}
                            onChange={(e) =>
                              setIsActive(e.target.value === "true")
                            }
                          />{" "}
                          False
                        </label>
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
              </div>
            </div>
          </div>

          <DialogFooter className="gap-2">
            <Button
              onClick={() => {
                if (editIndex === null) {
                  addItem();
                } else {
                  updateItem(editIndex);
                }
              }}
              className="bg-blue-600 hover:bg-blue-700"
            >
              {editIndex === null ? "Add Relation " : "Update Relation "}
            </Button>
            <Button
              variant="outline"
              onClick={(e) => {
                setEditIndex(null);
                clear();
                setIsDialogOpen(false);
              }}
            >
              Cancel
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <Toaster />
    </div>
  );
};

export default DrugCustomGroups;
